// /* eslint-disable @typescript-eslint/no-unused-vars */
// import React, { useState } from "react";
// import { T, useLanguage } from "../../../context/LanguageContext";
// import { useNavigate } from "react-router-dom";
// import { formatDateTimeNew } from "../../../utilities/helper";

// type Shipment = {
//   id: string;
//   sn: number;
//   orderType: string;
//   createdAt: string;
//   platform: string;
//   awbNumber: string;
//   referenceNumber: string;
//   warehouseName: string;
//   routeCode?: string;
//   route_code?: string;
//   route?: any;
//   shippingCompany: string;
//   shippingAwbNumber: string;
//   senderCityName?: string;
//   senderCityData?: string;
//   senderCity?: any;
//   receiverCityName?: string;
//   receiverCityData?: string;
//   receiverCity?: any;
//   receiverCountryName?: string;
//   receiverCountryData?: string;
//   receiverCountry?: any;
//   receiverDistrictName?: string;
//   receiverDistrictData?: string;
//   receiverDistrict?: any;
//   receiverNationalAddress?: string;
//   receiverShortAddress?: string;
//   shortAddress?: string;
//   receiverZipCode?: string;
//   zipCode?: string;
//   receiverStreet?: string;
//   receiverAddress?: string;
//   receiverName: string;
//   receiverMobile: string;
//   paymentType: string;
//   codAmount: number;
//   status: string;
//   clientName: string;
//   customerName?: string;
//   outletName?: string;
//   senderName?: string;
//   olineItems: {
//     itemName: string;
//     sku: string;
//     quantity: number;
//     weight: number;
//     price: number;
//     description?: string;
//   }[];
// };

// type Props = {
//   data: {
//     orders: Shipment[];
//   };
//   columnsData: any[];
//   currentPage?: number;
//   limitPage?: number;
//   isCheckboxEnabled?: boolean;
//   selectedOrders?: Shipment[];
//   onSelectOrder?: (order: Shipment) => void;
//   onViewDetails?: (awb: string) => void;
//   showRightPanel?: boolean;
//   // Backward-compatibility props
//   onEdit?: (shipment: Shipment) => void;
//   onLabelPrint?: (shipment: Shipment) => void;
//   onForward3PL?: (shipment: Shipment) => void;
//   onReverseOrder?: (shipment: Shipment) => void;
//   onSMS?: (shipment: Shipment) => void;
//   onDelete?: (shipment: Shipment) => void;
//   openRevertModal?: (shipment: Shipment) => void;
//   type?: string;
//   orderType?: boolean;
//   pending?: boolean;
// };

// const getStatusLabel = (status: string) => {
//   const normStatus = (status || "").toUpperCase();
//   const labels: Record<string, string> = {
//     NEW_ORDER: "New Order",
//     ORDER_GENERATED: "Order Generated",
//     ORDER_CREATED: "Order Created",
//     PROCESSING: "Processing",
//     READY_FOR_PICKUP: "Ready For Pickup",
//     READY_TO_PICK: "Ready To Pick",
//     PACKED: "Packed",
//     DISPATCHED: "Dispatched",
//     IN_TRANSIT: "In Transit",
//     OUT_FOR_DELIVERY: "Out For Delivery",
//     DELIVERED: "Delivered",
//     UNDELIVERED: "Undelivered",
//     RETURNED: "Returned",
//     REVERSE_NEW: "Reverse New",
//     DELETED: "Deleted",
//     FAILED: "Failed",
//     LOST: "Lost",
//     DRAFT: "Draft",
//     CANCELLED: "Cancelled",
//     RECEIVE_IN_WAREHOUSE: "Receive In Warehouse",
//     PICKUP_GENERATED: "Pickup Generated",
//     RETURN_TO_SHIPPER: "Return To Shipper",
//     FORWARD_TO_3PL: "Forward To 3PL",
//     DISPATCHED_TO_3PL: "Dispatched To 3PL",
//     PICKUP_COLLECTED: "Pickup Collected",
//     PICKLIST_GENERATED: "Picklist Generated",
//     PICKED: "Picked",
//     RECEIVE_INBOUND: "Receive Inbound",
//     SHELVE: "Shelve",
//     PENDING: "Pending",
//     PENDING_STOCK: "Pending Stock",
//   };
//   if (labels[normStatus]) return labels[normStatus];
//   return status
//     ? status
//         .split("_")
//         .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//         .join(" ")
//     : "Unknown";
// };

// const AllOrderTable: React.FC<Props> = ({
//   data,
//   columnsData,
//   isCheckboxEnabled = true,
//   selectedOrders = [],
//   onSelectOrder,
//   onViewDetails,
//   showRightPanel,
// }) => {
//   const navigate = useNavigate();
//   const { t } = useLanguage();
//   const [expandedRow, setExpandedRow] = useState<string | null>(null);

//   const isColShow = (val: string) => {
//     if (!columnsData || columnsData.length === 0) return true;
//     return columnsData.find((col) => col.value === val)?.isShow !== false;
//   };

//   const getMinWidth = () => {
//     let width = isCheckboxEnabled ? 50 : 0;
//     if (isColShow("sn")) width += 40;
//     if (isColShow("tag")) width += 40;
//     if (isColShow("createdDate")) width += 120;
//     if (isColShow("platform")) width += 90;
//     if (isColShow("awbRef")) width += 180;
//     if (isColShow("warehouse")) width += 160;
//     if (isColShow("route")) width += 80;
//     if (isColShow("shippingDetails")) width += 180;
//     if (isColShow("origin")) width += 110;
//     if (isColShow("destination")) width += 190;
//     if (isColShow("address")) width += 190;
//     if (isColShow("receiverDetails")) width += 160;
//     if (isColShow("paymentInfo")) width += 120;
//     if (isColShow("merchant")) width += 160;
//     if (isColShow("actions")) width += 100;
//     if (isColShow("status")) width += 120;
//     return width;
//   };

//   const toggleRow = (id: string) => {
//     setExpandedRow((prev) => (prev === id ? null : id));
//   };

//   return (
//     <div className="overflow-y-auto overflow-x-auto  max-h-[calc(100vh-18rem)] hide-scrollbar shadow-inner">
//       {!data?.orders || data.orders.length === 0 ? (
//         <div className="py-16 text-left">
//           <p className="text-slate-400 text-sm font-semibold">
//             <T>No orders found matching the filter</T>
//           </p>
//         </div>
//       ) : (
//         <table
//           className="w-full text-left border-collapse overflow-x-auto"
//           style={{
//             minWidth: showRightPanel ? `${getMinWidth() * 0.8}px` : "100%",
//           }}
//         >
//           <colgroup>
//             {isCheckboxEnabled && <col style={{ width: "2%" }} />}
//             {isColShow("sn") && <col style={{ width: "2%" }} />}
//             {isColShow("tag") && <col style={{ width: "3%" }} />}
//             {isColShow("createdDate") && <col style={{ width: "10%" }} />}
//             {isColShow("platform") && <col style={{ width: "5%" }} />}
//             {isColShow("awbRef") && <col style={{ width: "9%" }} />}
//             {isColShow("warehouse") && <col style={{ width: "8%" }} />}
//             {isColShow("route") && <col style={{ width: "4%" }} />}
//             {isColShow("shippingDetails") && <col style={{ width: "8%" }} />}
//             {isColShow("origin") && <col style={{ width: "6%" }} />}
//             {isColShow("destination") && <col style={{ width: "8.5%" }} />}
//             {isColShow("address") && <col style={{ width: "8.5%" }} />}
//             {isColShow("receiverDetails") && <col style={{ width: "8.5%" }} />}
//             {isColShow("paymentInfo") && <col style={{ width: "6%" }} />}
//             {isColShow("merchant") && <col style={{ width: "8.5%" }} />}
//             {isColShow("actions") && <col style={{ width: "5.5%" }} />}
//             {isColShow("status") && <col style={{ width: "7.5%" }} />}
//           </colgroup>

//           <thead className="text-[#212121]/90 font-bold border-b border-t border-dashed border-gray-300 sticky top-0 z-20 bg-[#E0E0E0]">
//             <tr className="text-left text-[11px] font-bold tracking-wider uppercase select-none whitespace-nowrap">
//               {isCheckboxEnabled && (
//                 <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
//                   <div className="flex items-center justify-center">
//                     <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
//                       <input
//                         type="checkbox"
//                         checked={
//                           data.orders.length > 0 &&
//                           selectedOrders.length === data.orders.length
//                         }
//                         onChange={(e) => {
//                           const checked = e.target.checked;
//                           data.orders.forEach((order) => {
//                             const isSelected = selectedOrders.some(
//                               (o) => o.id === order.id,
//                             );
//                             if (checked && !isSelected) onSelectOrder?.(order);
//                             else if (!checked && isSelected)
//                               onSelectOrder?.(order);
//                           });
//                         }}
//                         className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
//                       />
//                       <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
//                         ✓
//                       </span>
//                     </label>
//                   </div>
//                 </th>
//               )}

//               {isColShow("sn") && (
//                 <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300 text-left">
//                   <T>S/N</T>
//                 </th>
//               )}
//               {isColShow("tag") && (
//                 <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300 text-left">
//                   <T>Tag</T>
//                 </th>
//               )}
//               {isColShow("createdDate") && (
//                 <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300 whitespace-nowrap text-left">
//                   <T>Date & Time</T>
//                 </th>
//               )}
//               {isColShow("platform") && (
//                 <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
//                   <T>Platform</T>
//                 </th>
//               )}
//               {isColShow("awbRef") && (
//                 <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
//                   <T>AWB / Ref</T>
//                 </th>
//               )}
//               {isColShow("warehouse") && (
//                 <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
//                   <T>Warehouse</T>
//                 </th>
//               )}
//               {isColShow("route") && (
//                 <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
//                   <T>Route</T>
//                 </th>
//               )}
//               {isColShow("shippingDetails") && (
//                 <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
//                   <T>3PL Shipping</T>
//                 </th>
//               )}
//               {isColShow("origin") && (
//                 <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
//                   <T>Origin</T>
//                 </th>
//               )}
//               {isColShow("destination") && (
//                 <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
//                   <T>Destination</T>
//                 </th>
//               )}
//               {isColShow("address") && (
//                 <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
//                   <T>Address</T>
//                 </th>
//               )}
//               {isColShow("receiverDetails") && (
//                 <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
//                   <T>Receiver</T>
//                 </th>
//               )}
//               {isColShow("paymentInfo") && (
//                 <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
//                   <T>Payment</T>
//                 </th>
//               )}
//               {isColShow("merchant") && (
//                 <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
//                   <T>Merchant</T>
//                 </th>
//               )}
//               {isColShow("actions") && (
//                 <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300 text-left">
//                   <T>Products</T>
//                 </th>
//               )}
//               {isColShow("status") && (
//                 <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 text-left">
//                   <T>Status</T>
//                 </th>
//               )}
//             </tr>
//           </thead>

//           <tbody className="divide-y divide-gray-100">
//             {data.orders.map((item, idx) => {
//               const isExpanded = expandedRow === item.id;
//               const isSelected = selectedOrders.some((o) => o.id === item.id);

//               return (
//                 <React.Fragment key={`${item.id}-${item.paymentType || idx}`}>
//                   <tr
//                     onDoubleClick={() =>
//                       onViewDetails
//                         ? onViewDetails(item.awbNumber)
//                         : navigate(`/orders/${item.awbNumber}`)
//                     }
//                     className={`  group transition-colors duration-150 cursor-pointer select-none ${
//                       isSelected ? "bg-white/20/30" : ""
//                     }`}
//                   >
//                     {/* Checkbox */}
//                     {isCheckboxEnabled && (
//                       <td
//                         className="px-2 py-3 border-r border-dashed border-gray-200"
//                         onClick={(e) => e.stopPropagation()}
//                       >
//                         <div className="flex items-center justify-center">
//                           <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
//                             <input
//                               type="checkbox"
//                               checked={isSelected}
//                               onChange={() => onSelectOrder?.(item)}
//                               className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
//                             />
//                             <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
//                               ✓
//                             </span>
//                           </label>
//                         </div>
//                       </td>
//                     )}

//                     {/* S/N */}
//                     {isColShow("sn") && (
//                       <td className="px-2 py-3 border-r border-dashed border-gray-200 text-xs font-bold text-slate-600">
//                         {idx + 1}
//                       </td>
//                     )}

//                     {/* TAG */}
//                     {isColShow("tag") && (
//                       <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 text-left">
//                         <span className="inline-block px-2 py-0.5 rounded-md text-[11px] font-semibold uppercase tracking-wide border border-slate-200 bg-white/20 text-slate-700">
//                           <T>{item.orderType || "LM"}</T>
//                         </span>
//                       </td>
//                     )}

//                     {/* DATE */}
//                     {isColShow("createdDate") && (
//                       <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 whitespace-nowrap text-left">
//                         <div className="text-xs font-semibold text-slate-700 text-left">
//                           {formatDateTimeNew(item.createdAt)}
//                         </div>
//                       </td>
//                     )}

//                     {/* PLATFORM */}
//                     {isColShow("platform") && (
//                       <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0">
//                         {item.platform ? (
//                           <span className="inline-block bg-white/20 border border-slate-200 text-slate-600 px-2 py-0.5 rounded text-[11px] font-semibold max-w-full">
//                             <T>{item.platform}</T>
//                           </span>
//                         ) : (
//                           <span className="text-slate-300">-</span>
//                         )}
//                       </td>
//                     )}

//                     {/* AWB NO. / REF */}
//                     {isColShow("awbRef") && (
//                       <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0">
//                         <div className="text-xs font-bold text-slate-800">
//                           {item.awbNumber}
//                         </div>
//                         <div className="text-[10px] text-slate-400 font-medium mt-0.5">
//                           {t("ref:")} {item.referenceNumber}
//                         </div>
//                       </td>
//                     )}

//                     {/* WAREHOUSE */}
//                     {isColShow("warehouse") && (
//                       <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 text-left">
//                         <div
//                           className="text-xs font-medium text-slate-700 truncate"
//                           data-tooltip={
//                             item.platform === "OUTLET"
//                               ? item.outletName || item.warehouseName
//                               : item.warehouseName
//                           }
//                         >
//                           {item.platform === "OUTLET"
//                             ? item.outletName || item.warehouseName
//                             : item.warehouseName}
//                         </div>
//                       </td>
//                     )}

//                     {/* ROUTE */}
//                     {isColShow("route") && (
//                       <td className="px-2 py-3 border-r border-dashed border-gray-200 text-left">
//                         {(() => {
//                           const rCode =
//                             item.routeCode ||
//                             item.route_code ||
//                             (typeof item.route === "object"
//                               ? item.route?.code || item.route?.name
//                               : item.route) ||
//                             "";
//                           return rCode ? (
//                             <span className="inline-flex items-center text-slate-700 px-2 py-0.5 rounded text-[11px] font-semibold max-w-full truncate">
//                               {rCode}
//                             </span>
//                           ) : (
//                             <span className="text-slate-300">-</span>
//                           );
//                         })()}
//                       </td>
//                     )}

//                     {/* 3PL Shipping */}
//                     {isColShow("shippingDetails") && (
//                       <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 text-left">
//                         <div className="text-xs font-semibold text-slate-700 truncate">
//                           {item.shippingCompany}
//                         </div>
//                         <div className="text-[10px] text-slate-400 mt-0.5 truncate">
//                           {item.shippingAwbNumber}
//                         </div>
//                       </td>
//                     )}

//                     {/* Origin */}
//                     {isColShow("origin") && (
//                       <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 text-left">
//                         {(() => {
//                           const senderCity =
//                             item.senderCityName ||
//                             item.senderCityData ||
//                             (typeof item.senderCity === "object"
//                               ? item.senderCity?.name
//                               : item.senderCity) ||
//                             "";
//                           const originParts = (senderCity || "").split(" ");
//                           const originCity = originParts[0] || senderCity || "";
//                           const originWhse = originParts.slice(1).join(" ");
//                           return (
//                             <>
//                               <div className="text-xs font-bold text-slate-700 truncate">
//                                 <T>{originCity}</T>
//                               </div>
//                               {originWhse && (
//                                 <div className="text-[10px] text-slate-400 font-medium truncate">
//                                   <T>{originWhse}</T>
//                                 </div>
//                               )}
//                             </>
//                           );
//                         })()}
//                       </td>
//                     )}

//                     {/* Destination */}
//                     {isColShow("destination") && (
//                       <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 max-w-0 overflow-hidden">
//                         {(() => {
//                           const cityName =
//                             item.receiverCityName ||
//                             item.receiverCityData ||
//                             (typeof item.receiverCity === "object"
//                               ? item.receiverCity?.name
//                               : item.receiverCity) ||
//                             "";
//                           const countryName =
//                             item.receiverCountryName ||
//                             item.receiverCountryData ||
//                             (typeof item.receiverCountry === "object"
//                               ? item.receiverCountry?.name
//                               : item.receiverCountry) ||
//                             "";
//                           const districtName =
//                             item.receiverDistrictName ||
//                             item.receiverDistrictData ||
//                             (typeof item.receiverDistrict === "object"
//                               ? item.receiverDistrict?.name
//                               : item.receiverDistrict) ||
//                             "";
//                           const shortAddr =
//                             item.receiverNationalAddress ||
//                             item.receiverShortAddress ||
//                             item.shortAddress ||
//                             item.receiverZipCode ||
//                             item.zipCode ||
//                             "";
//                           return (
//                             <>
//                               <div
//                                 className="text-xs font-bold text-slate-700 truncate"
//                                 title={`${cityName ? t(cityName) : ""}${
//                                   cityName && countryName ? `, ` : ""
//                                 }${countryName ? t(countryName) : ""}`}
//                               >
//                                 {cityName && <T>{cityName}</T>}
//                                 {cityName && countryName ? `, ` : ""}
//                                 {countryName && <T>{countryName}</T>}
//                               </div>
//                               <div className="text-[9px] text-slate-400 font-bold flex items-center gap-1 mt-1">
//                                 {districtName && (
//                                   <span
//                                     className="truncate"
//                                     title={`${t("Dist:")} ${t(districtName)}`}
//                                   >
//                                     {t("Dist:")} <T>{districtName}</T>
//                                   </span>
//                                 )}
//                                 {shortAddr && (
//                                   <span
//                                     className="border border-slate-200 bg-white/20 text-slate-500 px-1 rounded font-mono text-[9px] max-w-[80px]"
//                                     title={shortAddr}
//                                   >
//                                     {shortAddr}
//                                   </span>
//                                 )}
//                               </div>
//                             </>
//                           );
//                         })()}
//                       </td>
//                     )}

//                     {/* Address */}
//                     {isColShow("address") && (
//                       <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 max-w-0 overflow-hidden text-left">
//                         <div
//                           className="text-[10px] text-slate-700"
//                           title={item.receiverAddress}
//                         >
//                           {item.receiverAddress}
//                         </div>
//                       </td>
//                     )}

//                     {/* Receiver */}
//                     {isColShow("receiverDetails") && (
//                       <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 max-w-0 overflow-hidden text-left">
//                         <div className="text-xs font-bold text-slate-700 truncate">
//                           {item.receiverName}
//                         </div>
//                         <div className="text-[10px] text-slate-400 mt-0.5 truncate">
//                           {item.receiverMobile}
//                         </div>
//                       </td>
//                     )}

//                     {/* Payment */}
//                     {isColShow("paymentInfo") && (
//                       <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 text-left">
//                         <span
//                           className="inline-block px-2 py-0.5 rounded text-[11px] font-semibold uppercase tracking-wide text-slate-700 max-w-full"
//                           data-tooltip={
//                             item.paymentType === "COD"
//                               ? `${t("COD")}: ${item.codAmount ?? 0}`
//                               : t("CC: PAID")
//                           }
//                         >
//                           {item.paymentType === "COD"
//                             ? `${t("COD")}: ${item.codAmount ?? 0}`
//                             : t("CC: PAID")}
//                         </span>
//                       </td>
//                     )}

//                     {/* Merchant */}
//                     {isColShow("merchant") && (
//                       <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 text-left">
//                         <span
//                           className="text-xs font-bold text-slate-700 block truncate"
//                           data-tooltip={
//                             item.platform === "OUTLET"
//                               ? item.senderName || item.clientName
//                               : item.clientName
//                           }
//                         >
//                           {item.platform === "OUTLET"
//                             ? item.senderName || item.clientName
//                             : item.clientName}
//                         </span>
//                       </td>
//                     )}

//                     {/* Products */}
//                     {isColShow("actions") && (
//                       <td
//                         className="px-2 py-3 border-r border-dashed border-gray-200 text-left"
//                         onClick={(e) => e.stopPropagation()}
//                       >
//                         {(item.olineItems?.length ?? 0) > 0 && (
//                           <button
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               toggleRow(item.id);
//                             }}
//                             className={`inline-flex items-center gap-1.5 px-3 py-1 text-[11px] rounded-lg border transition-all duration-150 select-none shadow-sm whitespace-nowrap ${
//                               isExpanded
//                                 ? "bg-[#FBD037] border-[#FBD037] text-[#131327]"
//                                 : "bg-white/20 border-slate-200 hover:border-slate-400 text-slate-700 hover:bg-slate-200/60"
//                             }`}
//                           >
//                             <span>
//                               {(item.olineItems?.length ?? 0) === 1 ? (
//                                 <T>Product</T>
//                               ) : (
//                                 <T>Products</T>
//                               )}
//                             </span>
//                           </button>
//                         )}
//                       </td>
//                     )}

//                     {/* Status */}
//                     {isColShow("status") && (
//                       <td className="px-2 py-3 text-left">
//                         <span className="inline-block px-2 py-1.5 rounded-lg whitespace-nowrap text-[11px] font-semibold tracking-wide border border-slate-200 bg-white/20 text-slate-700">
//                           <T>{getStatusLabel(item.status)}</T>
//                         </span>
//                       </td>
//                     )}
//                   </tr>

//                   {/* Expanded Products Drawer */}
//                   {isExpanded && (
//                     <tr className="bg-white/20/30">
//                       {isCheckboxEnabled && <td className="p-0" />}
//                       {isColShow("sn") && <td className="p-0" />}
//                       {isColShow("tag") && <td className="p-0" />}
//                       <td
//                         colSpan={
//                           [
//                             "createdDate",
//                             "platform",
//                             "awbRef",
//                             "warehouse",
//                             "route",
//                             "shippingDetails",
//                             "origin",
//                             "destination",
//                             "address",
//                             "receiverDetails",
//                             "paymentInfo",
//                             "merchant",
//                             "actions",
//                           ].filter(isColShow).length
//                         }
//                         className="py-2 border-b border-dashed border-gray-200"
//                       >
//                         <div className="rounded-lg border border-dashed border-gray-300">
//                           <div className="overflow-x-auto">
//                             {/* Expanded Header */}
//                             <div className="grid grid-cols-[0.5fr_2fr_2fr_0.5fr_0.5fr_0.5fr_2fr] border-b border-dashed border-gray-300 bg-[#E0E0E0]">
//                               <div className="px-2 py-2 border-r border-dashed border-gray-200 text-[11px] font-semibold tracking-wider uppercase text-[#131327]/70">
//                                 <T>SN.</T>
//                               </div>
//                               <div className="px-2 py-2 border-r border-dashed border-gray-200 text-[11px] font-semibold tracking-wider uppercase text-[#131327]/70">
//                                 <T>SKU</T>
//                               </div>
//                               <div className="px-2 py-2 border-r border-dashed border-gray-200 text-[11px] font-semibold tracking-wider uppercase text-[#131327]/70">
//                                 <T>Product Name</T>
//                               </div>
//                               <div className="px-2 py-2 border-r border-dashed border-gray-200 text-[11px] font-semibold tracking-wider uppercase text-[#131327]/70">
//                                 <T>Weight</T>
//                               </div>
//                               <div className="px-2 py-2 border-r border-dashed border-gray-200 text-[11px] font-semibold tracking-wider uppercase text-[#131327]/70">
//                                 <T>Qty</T>
//                               </div>
//                               <div className="px-2 py-2 border-r border-dashed border-gray-200 text-[11px] font-semibold tracking-wider uppercase text-[#131327]/70">
//                                 <T>Price</T>
//                               </div>
//                               <div className="px-2 py-2 border-gray-200 text-[11px] font-semibold tracking-wider uppercase text-[#131327]/70">
//                                 <T>Description</T>
//                               </div>
//                             </div>

//                             {/* Items */}
//                             {(item.olineItems ?? []).map((lineItem, lineIdx) => (
//                               <div
//                                 key={lineIdx}
//                                 className="grid grid-cols-[0.5fr_2fr_2fr_0.5fr_0.5fr_0.5fr_2fr] items-center border-b border-dashed border-gray-200 last:border-b-0 bg-[#FCFDF8] hover:bg-[#FBD037]/10 transition-colors"
//                               >
//                                 <div className="px-3 py-2 border-r border-dashed">
//                                   <span className="text-[11px] font-bold text-slate-700">
//                                     {lineIdx + 1}
//                                   </span>
//                                 </div>
//                                 <div className="px-3 py-2 border-r border-dashed">
//                                   <span className="text-[11px] font-bold text-slate-700">
//                                     {lineItem.sku || "-"}
//                                   </span>
//                                 </div>
//                                 <div className="px-3 py-3 min-w-0 border-r border-dashed">
//                                   <span
//                                     className="block truncate text-[11px] font-semibold text-slate-700"
//                                     title={lineItem.itemName}
//                                   >
//                                     {lineItem.itemName || "-"}
//                                   </span>
//                                 </div>
//                                 <div className="px-3 py-2 border-r border-dashed">
//                                   <span className="text-[11px] font-semibold text-slate-600">
//                                     {lineItem.weight ?? "-"} Kg
//                                   </span>
//                                 </div>
//                                 <div className="px-3 py-2 border-r border-dashed">
//                                   <span className="text-[11px] font-semibold text-slate-600">
//                                     {lineItem.quantity ?? 0}
//                                   </span>
//                                 </div>
//                                 <div className="px-3 py-2 border-r border-dashed">
//                                   <span className="text-[11px] font-semibold text-slate-600">
//                                     {lineItem.price ?? ""}
//                                   </span>
//                                 </div>
//                                 <div className="px-3 py-2 min-w-0">
//                                   <span
//                                     className="block truncate text-[11px] font-semibold text-slate-500"
//                                     title={lineItem.description || ""}
//                                   >
//                                     {lineItem.description || "-"}
//                                   </span>
//                                 </div>
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       </td>
//                       {isColShow("status") && <td className="p-0" />}
//                     </tr>
//                   )}
//                 </React.Fragment>
//               );
//             })}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// };

// export default AllOrderTable;

import React, { useState } from "react";
import { T, useLanguage } from "../../../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { formatDateTimeNew } from "../../../utilities/helper";

type Shipment = {
  id: string;
  sn: number;
  orderType: string;
  createdAt: string;
  platform: string;
  awbNumber: string;
  referenceNumber: string;
  warehouseName: string;
  routeCode: string;
  shippingCompany: string;
  shippingAwbNumber: string;
  senderCityName: string;
  receiverCityName: string;
  receiverCountryName: string;
  receiverDistrictName: string;
  receiverCityData?: string;
  receiverCountryData?: string;
  receiverDistrictData?: string;
  senderCityData?: string;
  senderCountryData?: string;
  senderDistrictData?: string;
  receiverNationalAddress: string;
  receiverAddress?: string;
  receiverName: string;
  receiverMobile: string;
  receiverEmail?: string;
  paymentType: string;
  codAmount: number;
  status: string;
  comment?: string;
  reason?: string;
  orderStatusHistories?: { comment?: string; details?: string }[];
  updatedAt: string;
  dispatchStatus: string;
  clientName: string;
  customerName?: string;
  outletName?: string;
  senderName?: string;
  olineItems: {
    itemName: string;
    sku: string;
    quantity: number;
    weight: number;
    price: number;
    binLocation: string;
    inventory: number;
    description?: string;
  }[];
};

type Props = {
  data: {
    orders: Shipment[];
  };
  columnsData: any[];
  currentPage: number;
  limitPage: number;
  isCheckboxEnabled: boolean;
  selectedOrders: Shipment[];
  onSelectOrder: (order: Shipment) => void;
  onViewDetails?: (awb: string) => void;
  showRightPanel?: boolean;
};

// Removed color mapping – now returns only the label in a neutral style
const getStatusLabel = (status: string) => {
  const normStatus = (status || "").toUpperCase();
  const labels: Record<string, string> = {
    NEW_ORDER: "New Order",
    ORDER_GENERATED: "Order Generated",
    ORDER_CREATED: "Order Created",
    PROCESSING: "Processing",
    READY_FOR_PICKUP: "Ready For Pickup",
    READY_TO_PICK: "Ready To Pick",
    PACKED: "Packed",
    DISPATCHED: "Dispatched",
    IN_TRANSIT: "In Transit",
    OUT_FOR_DELIVERY: "Out For Delivery",
    DELIVERED: "Delivered",
    UNDELIVERED: "Undelivered",
    RETURNED: "Returned",
    REVERSE_NEW: "Reverse New",
    DELETED: "Deleted",
    FAILED: "Failed",
    LOST: "Lost",
    DRAFT: "Draft",
    CANCELLED: "Cancelled",
    RECEIVE_IN_WAREHOUSE: "Receive In Warehouse",
    PICKUP_GENERATED: "Pickup Generated",
    RETURN_TO_SHIPPER: "Return To Shipper",
    FORWARD_TO_3PL: "Forward To 3PL",
    DISPATCHED_TO_3PL: "Dispatched To 3PL",
    PICKUP_COLLECTED: "Pickup Collected",
    PICKLIST_GENERATED: "Picklist Generated",
    PICKED: "Picked",
    RECEIVE_INBOUND: "Receive Inbound",
    SHELVE: "Shelve",
    PENDING: "Pending",
    PENDING_STOCK: "Pending Stock",
  };
  if (labels[normStatus]) return labels[normStatus];
  return status
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

const AllOrderTable: React.FC<Props> = ({
  data,
  columnsData,
  isCheckboxEnabled,
  selectedOrders,
  onSelectOrder,
  onViewDetails,
  showRightPanel,
}) => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [expandedRow, setExpandedRow] = useState<string | null>(null);

  const isColShow = (val: string) => {
    if (!columnsData || columnsData.length === 0) return true;
    return columnsData.find((col) => col.value === val)?.isShow !== false;
  };

  const getMinWidth = () => {
    let width = isCheckboxEnabled ? 50 : 0;
    if (isColShow("sn")) width += 40;
    if (isColShow("tag")) width += 40;
    if (isColShow("createdDate")) width += 120;
    if (isColShow("platform")) width += 90;
    if (isColShow("awbRef")) width += 180;
    if (isColShow("warehouse")) width += 160;
    if (isColShow("route")) width += 80;
    if (isColShow("shippingDetails")) width += 180;
    if (isColShow("origin")) width += 110;
    if (isColShow("destination")) width += 190;
    if (isColShow("address")) width += 190;
    if (isColShow("receiverDetails")) width += 160;
    if (isColShow("paymentInfo")) width += 120;
    if (isColShow("merchant")) width += 160;
    if (isColShow("actions")) width += 100;
    if (isColShow("status")) width += 120;
    return width;
  };

  const toggleRow = (id: string) => {
    setExpandedRow((prev) => (prev === id ? null : id));
  };

  return (
    <div className="overflow-y-auto overflow-x-auto max-h-[calc(100vh-18rem)] hide-scrollbar  shadow-inner">
      {data.orders.length === 0 ? (
        <div className="py-16 text-left">
          <p className="text-slate-400 text-sm font-semibold">
            <T>No orders found matching the filter</T>
          </p>
        </div>
      ) : (
        <table
          className="w-full text-left border-collapse overflow-x-auto "
          style={{
            minWidth: showRightPanel ? `${getMinWidth() * 0.8}px` : "100%",
          }}
        >
          <colgroup>
            {isCheckboxEnabled && <col style={{ width: "2%" }} />}
            {isColShow("sn") && <col style={{ width: "2%" }} />}
            {isColShow("tag") && <col style={{ width: "3%" }} />}
            {isColShow("createdDate") && <col style={{ width: "10%" }} />}
            {isColShow("platform") && <col style={{ width: "5%" }} />}
            {isColShow("awbRef") && <col style={{ width: "9%" }} />}
            {isColShow("warehouse") && <col style={{ width: "8%" }} />}
            {isColShow("route") && <col style={{ width: "4%" }} />}
            {isColShow("shippingDetails") && <col style={{ width: "8%" }} />}
            {isColShow("origin") && <col style={{ width: "6%" }} />}
            {isColShow("destination") && <col style={{ width: "8.5%" }} />}
            {isColShow("address") && <col style={{ width: "8.5%" }} />}
            {isColShow("receiverDetails") && <col style={{ width: "8.5%" }} />}
            {isColShow("paymentInfo") && <col style={{ width: "6%" }} />}
            {isColShow("merchant") && <col style={{ width: "8.5%" }} />}
            {isColShow("actions") && <col style={{ width: "5.5%" }} />}
            {isColShow("status") && <col style={{ width: "7.5%" }} />}
          </colgroup>

          <thead className="text-[#212121]/90 font-bold border-b border-t border-dashed border-gray-300 sticky top-0 z-20 bg-[#E0E0E0]">
            <tr className="text-left text-[11px] font-bold tracking-wider uppercase select-none whitespace-nowrap">
              {isCheckboxEnabled && (
                <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
                  <div className="flex items-center justify-center">
                    <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
                      <input
                        type="checkbox"
                        checked={
                          data.orders.length > 0 &&
                          selectedOrders.length === data.orders.length
                        }
                        onChange={(e) => {
                          const checked = e.target.checked;
                          data.orders.forEach((order) => {
                            const isSelected = selectedOrders.some(
                              (o) => o.id === order.id,
                            );
                            if (checked && !isSelected) onSelectOrder(order);
                            else if (!checked && isSelected)
                              onSelectOrder(order);
                          });
                        }}
                        className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
                      />
                      <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
                        ✓
                      </span>
                    </label>
                  </div>
                </th>
              )}

              {isColShow("sn") && (
                <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300 text-left">
                  <T>S/N</T>
                </th>
              )}
              {isColShow("tag") && (
                <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300 text-left">
                  <T>Tag</T>
                </th>
              )}
              {isColShow("createdDate") && (
                <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300 whitespace-nowrap text-left">
                  <T>Date & Time</T>
                </th>
              )}
              {isColShow("platform") && (
                <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
                  <T>Platform</T>
                </th>
              )}
              {isColShow("awbRef") && (
                <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
                  <T>AWB / Ref</T>
                </th>
              )}
              {isColShow("warehouse") && (
                <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
                  <T>Warehouse</T>
                </th>
              )}
              {isColShow("route") && (
                <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
                  <T>Route</T>
                </th>
              )}
              {isColShow("shippingDetails") && (
                <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
                  <T>3PL Shipping</T>
                </th>
              )}
              {isColShow("origin") && (
                <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
                  <T>Origin</T>
                </th>
              )}
              {isColShow("destination") && (
                <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
                  <T>Destination</T>
                </th>
              )}
              {isColShow("address") && (
                <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
                  <T>Address</T>
                </th>
              )}
              {isColShow("receiverDetails") && (
                <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
                  <T>Receiver</T>
                </th>
              )}
              {isColShow("paymentInfo") && (
                <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
                  <T>Payment</T>
                </th>
              )}
              {isColShow("merchant") && (
                <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300">
                  <T>Merchant</T>
                </th>
              )}
              {isColShow("actions") && (
                <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 border-r border-dashed border-gray-300 text-left">
                  <T>Products</T>
                </th>
              )}
              {isColShow("status") && (
                <th className="px-2 pt-3 pb-2 font-bold text-xs text-[#212121]/90 text-left">
                  <T>Status</T>
                </th>
              )}
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-300 divide-dashed">
            {data.orders.map((item, idx) => {
              const isExpanded = expandedRow === item.id;
              const isSelected = selectedOrders.some((o) => o.id === item.id);

              return (
                <React.Fragment key={`${item.id}-${item.paymentType || idx}`}>
                  <tr
                    onDoubleClick={() =>
                      onViewDetails
                        ? onViewDetails(item.awbNumber)
                        : navigate(`/orders/${item.awbNumber}`)
                    }
                    className={`hover:bg-white/20 group transition-colors duration-150 cursor-pointer select-none ${
                      isSelected ? "bg-white/20/30" : ""
                    }`}
                  >
                    {/* Checkbox */}
                    {isCheckboxEnabled && (
                      <td
                        className="px-2 py-3 border-r border-dashed border-gray-200"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="flex items-center justify-center">
                          <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={() => onSelectOrder(item)}
                              className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
                            />
                            <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
                              ✓
                            </span>
                          </label>
                        </div>
                      </td>
                    )}

                    {/* S/N */}
                    {isColShow("sn") && (
                      <td className="px-2 py-3 border-r border-dashed border-gray-200 text-xs font-bold text-slate-600">
                        {idx + 1}
                      </td>
                    )}

                    {/* TAG */}
                    {isColShow("tag") && (
                      <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 text-left">
                        <span className="inline-block px-2 py-0.5 rounded-md text-[11px] font-semibold uppercase tracking-wide border border-slate-200 bg-white/20 text-slate-700">
                          <T>{item.orderType}</T>
                        </span>
                      </td>
                    )}

                    {/* DATE */}
                    {isColShow("createdDate") && (
                      <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 whitespace-nowrap text-left">
                        <div className="text-xs font-semibold text-slate-700 text-left">
                          {formatDateTimeNew(item.createdAt)}
                        </div>
                      </td>
                    )}

                    {/* PLATFORM */}
                    {isColShow("platform") && (
                      <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0">
                        {item.platform ? (
                          <span className="inline-block bg-white/20 border border-slate-200 text-slate-600 px-2 py-0.5 rounded text-[11px] font-semibold max-w-full">
                            <T>{item.platform}</T>
                          </span>
                        ) : (
                          <span className="text-slate-300">-</span>
                        )}
                      </td>
                    )}

                    {/* AWB NO. / REF */}
                    {isColShow("awbRef") && (
                      <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0">
                        <div className="text-xs font-bold text-slate-800">
                          {item.awbNumber}
                        </div>
                        <div className="text-[10px] text-slate-400 font-medium mt-0.5">
                          {t("ref:")} {item.referenceNumber}
                        </div>
                      </td>
                    )}

                    {/* WAREHOUSE */}
                    {isColShow("warehouse") && (
                      <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 text-left">
                        <div
                          className="text-xs font-medium text-slate-700 truncate"
                          data-tooltip={
                            item.platform === "OUTLET"
                              ? item.outletName || item.warehouseName
                              : item.warehouseName
                          }
                        >
                          {item.platform === "OUTLET"
                            ? item.outletName || item.warehouseName
                            : item.warehouseName}
                        </div>
                      </td>
                    )}

                    {/* ROUTE */}
                    {isColShow("route") && (
                      <td className="px-2 py-3 border-r border-dashed border-gray-200 text-left">
                        {item.routeCode ? (
                          <span className="inline-flex items-center text-slate-700 px-2 py-0.5 rounded text-[11px] font-semibold max-w-full truncate">
                            {item.routeCode}
                          </span>
                        ) : (
                          <span className="text-slate-300">-</span>
                        )}
                      </td>
                    )}

                    {/* 3PL Shipping */}
                    {isColShow("shippingDetails") && (
                      <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 text-left">
                        <div className="text-xs font-semibold text-slate-700 truncate">
                          {item.shippingCompany}
                        </div>
                        <div className="text-[10px] text-slate-400  mt-0.5 truncate">
                          {item.shippingAwbNumber}
                        </div>
                      </td>
                    )}

                    {/* Origin */}
                    {isColShow("origin") && (
                      <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 text-left">
                        {(() => {
                          const originParts = (item.senderCityName || "").split(
                            " ",
                          );
                          const originCity = originParts[0] || "";
                          const originWhse = originParts.slice(1).join(" ");
                          return (
                            <>
                              <div className="text-xs font-bold text-slate-700 truncate">
                                <T>{originCity}</T>
                              </div>
                              {originWhse && (
                                <div className="text-[10px] text-slate-400 font-medium truncate">
                                  <T>{originWhse}</T>
                                </div>
                              )}
                            </>
                          );
                        })()}
                      </td>
                    )}

                    {/* Destination */}
                    {isColShow("destination") && (
                      <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 max-w-0 overflow-hidden">
                        {(() => {
                          const cityName =
                            item.receiverCityName ||
                            item.receiverCityData ||
                            "";
                          const countryName =
                            item.receiverCountryName ||
                            item.receiverCountryData ||
                            "";
                          const districtName =
                            item.receiverDistrictName ||
                            item.receiverDistrictData ||
                            "";
                          return (
                            <>
                              <div
                                className="text-xs font-bold text-slate-700 truncate"
                                title={`${cityName ? t(cityName) : ""}${cityName && countryName ? `, ` : ""}${countryName ? t(countryName) : ""}`}
                              >
                                {cityName && <T>{cityName}</T>}
                                {cityName && countryName ? `, ` : ""}
                                {countryName && <T>{countryName}</T>}
                              </div>
                              <div className="text-[9px] text-slate-400 font-bold flex items-center gap-1 mt-1">
                                {districtName && (
                                  <span
                                    className="truncate"
                                    title={`${t("Dist:")} ${t(districtName)}`}
                                  >
                                    {t("Dist:")} <T>{districtName}</T>
                                  </span>
                                )}
                                {item.receiverNationalAddress && (
                                  <span
                                    className="border border-slate-200 bg-white/20 text-slate-500 px-1 rounded font-mono text-[9px] max-w-[80px]"
                                    title={item.receiverNationalAddress}
                                  >
                                    {item.receiverNationalAddress}
                                  </span>
                                )}
                              </div>
                            </>
                          );
                        })()}
                      </td>
                    )}

                    {/* Receiver */}
                    {isColShow("address") && (
                      <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 max-w-0 overflow-hidden text-left">
                        <div
                          className="text-[10px] text-slate-700"
                          title={item.receiverAddress}
                        >
                          {item.receiverAddress}
                        </div>
                      </td>
                    )}
                    {isColShow("receiverDetails") && (
                      <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 max-w-0 overflow-hidden text-left">
                        <div className="text-xs font-bold text-slate-700 truncate">
                          {item.receiverName}
                        </div>
                        <div className="text-[10px] text-slate-400 mt-0.5 truncate">
                          {item.receiverMobile}
                        </div>
                      </td>
                    )}

                    {/* Payment */}
                    {isColShow("paymentInfo") && (
                      <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 text-left">
                        <span
                          className="inline-block px-2 py-0.5 rounded text-[11px] font-semibold uppercase tracking-wide   text-slate-700 max-w-full"
                          data-tooltip={
                            item.paymentType === "COD"
                              ? `${t("COD")}: ${item.codAmount ?? 0}`
                              : t("CC: PAID")
                          }
                        >
                          {item.paymentType === "COD"
                            ? `${t("COD")}: ${item.codAmount ?? 0}`
                            : t("CC: PAID")}
                        </span>
                      </td>
                    )}

                    {/* Merchant */}
                    {isColShow("merchant") && (
                      <td className="px-2 py-3 border-r border-dashed border-gray-200 min-w-0 text-left">
                        <span
                          className="text-xs font-bold text-slate-700 block truncate"
                          data-tooltip={
                            item.platform?.toUpperCase() === "APP" &&
                            item.orderType?.toUpperCase()?.includes("LM")
                              ? item.customerName || item.clientName
                              : item.platform === "OUTLET"
                                ? item.senderName || item.clientName
                                : item.clientName
                          }
                        >
                          {item.platform?.toUpperCase() === "APP" &&
                          item.orderType?.toUpperCase()?.includes("LM")
                            ? item.customerName || item.clientName
                            : item.platform === "OUTLET"
                              ? item.senderName || item.clientName
                              : item.clientName}
                        </span>
                      </td>
                    )}

                    {/* Items */}
                    {isColShow("actions") && (
                      <td
                        className="px-2 py-3 border-r border-dashed border-gray-200 text-left"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {(item.olineItems?.length ?? 0) > 0 && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleRow(item.id);
                            }}
                            className={`inline-flex items-center gap-1.5 px-3 py-1 text-[11px]  rounded-lg border transition-all duration-150 select-none shadow-sm whitespace-nowrap ${
                              isExpanded
                                ? "bg-[#FBD037] border-[#FBD037] text-[#131327]"
                                : "bg-white/20 border-slate-200 hover:border-slate-400 text-slate-700 "
                            }`}
                          >
                            <span>
                              {/* {item.olineItems?.length ?? 0}{" "} */}
                              {(item.olineItems?.length ?? 0) === 1 ? (
                                <T>Product</T>
                              ) : (
                                <T>Products</T>
                              )}
                            </span>
                          </button>
                        )}
                      </td>
                    )}

                    {/* Status */}
                    {isColShow("status") && (
                      <td className="px-2 py-3 text-left">
                        <span
                          className={`inline-block px-2 py-1.5 rounded-lg whitespace-nowrap text-[11px] font-semibold tracking-wide border ${
                            item.status === "PENDING_STOCK" || item.status === "PENDING"
                              ? "bg-amber-50 border-amber-300 text-amber-800"
                              : "border-slate-200 bg-white/20 text-slate-700"
                          }`}
                          title={
                            item.status === "PENDING_STOCK" || item.status === "PENDING"
                              ? item.comment || item.reason || (item.orderStatusHistories?.[0]?.comment) || "Item not found in client product catalog"
                              : undefined
                          }
                        >
                          <T>{getStatusLabel(item.status)}</T>
                        </span>
                      </td>
                    )}
                  </tr>
                  {isExpanded && (
                    <tr className="bg-white/20/30">
                      {isCheckboxEnabled && <td className="p-0" />}{" "}
                      {isColShow("sn") && <td className="p-0" />}{" "}
                      {isColShow("tag") && <td className="p-0" />}
                      <td
                        colSpan={
                          [
                            "createdDate",
                            "platform",
                            "awbRef",
                            "warehouse",
                            "route",
                            "shippingDetails",
                            "origin",
                            "destination",
                            "receiverDetails",
                            "paymentInfo",
                            "merchant",
                            "actions",
                          ].filter(isColShow).length
                        }
                        className="py-2 border-b border-dashed border-gray-200"
                      >
                        <div className="rounded-lg border border-dashed  ">
                          <div className="overflow-x-auto">
                            {/* Expanded Header */}
                            <div className="grid grid-cols-[0.5fr_2fr_2fr_0.5fr_0.5fr_0.5fr_2fr] border-b border-dashed border-gray-300 bg-gray-100">
                              <div className="px-2 py-2 border-r border-dashed border-gray-200 text-[11px] font-semibold tracking-wider uppercase text-[#131327]/70">
                                <T>SN.</T>
                              </div>
                              <div className="px-2 py-2 border-r border-dashed border-gray-200 text-[11px] font-semibold tracking-wider uppercase text-[#131327]/70">
                                <T>SKU</T>
                              </div>

                              <div className="px-2 py-2 border-r border-dashed border-gray-200 text-[11px] font-semibold tracking-wider uppercase text-[#131327]/70">
                                <T>Product Name</T>
                              </div>

                              <div className="px-2 py-2 border-r border-dashed border-gray-200 text-[11px] font-semibold tracking-wider uppercase text-[#131327]/70">
                                <T>Weight</T>
                              </div>

                              <div className="px-2 py-2 border-r border-dashed border-gray-200 text-[11px] font-semibold tracking-wider uppercase text-[#131327]/70">
                                <T>Qty</T>
                              </div>
                              <div className="px-2 py-2 border-r border-dashed border-gray-200 text-[11px] font-semibold tracking-wider uppercase text-[#131327]/70">
                                <T>Price</T>
                              </div>

                              <div className="px-2 py-2   border-gray-200 text-[11px] font-semibold tracking-wider uppercase text-[#131327]/70">
                                <T>Description</T>
                              </div>
                            </div>

                            {/* Items */}
                            {(item.olineItems ?? []).map(
                              (lineItem, lineIdx) => (
                                <div
                                  key={lineIdx}
                                  className="grid grid-cols-[0.5fr_2fr_2fr_0.5fr_0.5fr_0.5fr_2fr] items-center border-b border-dashed border-gray-200 last:border-b-0 hover:bg-white/20/70 transition-colors"
                                >
                                  {/* SKU */}
                                  <div className="px-3 py-2 border-r border-dashed">
                                    <span className="text-[11px] font-bold text-slate-700 ">
                                      {lineIdx + 1}
                                    </span>
                                  </div>
                                  <div className="px-3 py-2 border-r border-dashed">
                                    <span className="text-[11px] font-bold text-slate-700 ">
                                      {lineItem.sku || "-"}
                                    </span>
                                  </div>

                                  {/* Item Name */}
                                  <div className="px-3 py-3 min-w-0 border-r border-dashed">
                                    <span
                                      className="block truncate text-[11px] font-semibold text-slate-700"
                                      title={lineItem.itemName}
                                    >
                                      {lineItem.itemName || "-"}
                                    </span>
                                  </div>

                                  {/* Weight */}
                                  <div className="px-3 py-2 border-r border-dashed">
                                    <span className="text-[11px] font-semibold text-slate-600">
                                      {lineItem.weight ?? "-"} Kg
                                    </span>
                                  </div>

                                  {/* Quantity */}
                                  <div className="px-3 py-2  border-r border-dashed">
                                    <span className="text-[11px] font-semibold text-slate-600">
                                      {lineItem.quantity ?? 0}
                                    </span>
                                  </div>
                                  <div className="px-3 py-2  border-r border-dashed">
                                    <span className="text-[11px] font-semibold text-slate-600">
                                      {lineItem.price ?? ""}
                                    </span>
                                  </div>

                                  {/* Description */}
                                  <div className="px-3 py-2 min-w-0">
                                    <span
                                      className="block truncate text-[11px] font-semibold text-slate-500"
                                      title={lineItem.description || ""}
                                    >
                                      {lineItem.description || "-"}
                                    </span>
                                  </div>
                                </div>
                              ),
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AllOrderTable;
